import { Shield, ShieldCheck, ShieldAlert } from "lucide-react";
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  memo,
} from "react";
import Select from "react-select";
import { Edit2 } from "lucide-react";
import { FaPlus, FaRedo, FaSearch } from "react-icons/fa";
import {
  callToast,
  showErrorMessages,
} from "../../../../src/services/utilityFunctions.js";
import {getAcademicYearList} from "../../../services/Academic-Services.js";
// import AddHostelFacilityComponent from "./add-hostel-facilities-form.js";
import { useNavigate, useParams } from "react-router-dom";

import { updateGroupUser } from "../../../services/Users-services";

import { getLocalStorageData } from "../../../services/axiosComponent.js";
import { selectStyle } from "../../../services/constant.js";

export const InitialsAvatar = ({ displayName, onClick, item, tab2 }) => {
  // Get initials from display name
  const getInitials = (name) => {
    const names = name.split(" ");
    const first = names[0][0]?.toUpperCase() || "";
    const last = names[names.length - 1][0]?.toUpperCase() || "";
    return names.length > 1 ? `${first}${last}` : first;
  };

  // Generate consistent color based on initials
  const generateColor = (initials) => {
    const colors = [
      "#3B71CA", // blue
      "#54B4D3", // teal
      "#DC4C64", // red
      "#14A44D", // green
      "#E4A11B", // gold
      "#6965db", // purple
    ];
    const charCodeSum = [...initials].reduce(
      (acc, char) => acc + char.charCodeAt(0),
      0
    );
    return colors[charCodeSum % colors.length];
  };

  const initials = getInitials(displayName);
  const bgColor = generateColor(initials);
  const showBadge = () => {
    console.log("tab2  in avataor", tab2, " ", item);
    if (tab2 == "Users" && item._ADMIN == "Y") {
      return <AdminBadge />;
    } else if (tab2 == "Roles" && item.TYPE == "BASE-ROLE") {
      return <AdminBadge type="sub" />;
    }
    if (
      tab2 == "Group Users" &&
      item?.groupAdminId != null &&
      item?.groupAdminId != ""
    ) {
      return <AdminBadge type="sub" />;
    }
  };
  return (
    <div className="d-flex align-items-center    gap-3" onClick={onClick}>
      <div
        className="rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: bgColor,
          fontSize: "0.9rem",
          fontWeight: 500,
        }}
      >
        <span className="text-white">{initials}</span>
      </div>{" "}
      <div>
        <span className="  me-1 fw-medium">{displayName}</span>
        {showBadge() ? <AdminBadge /> : null}
      </div>
    </div>
  );
};
export const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};
export const AdminBadge = ({ type = "super" }) => {
  const getBadgeConfig = () => {
    switch (type.toLowerCase()) {
      case "super":
        return {
          icon: ShieldCheck,
          color: "#DC4C64",
          label: "Super Admin",
        };
      case "sub":
        return {
          icon: ShieldAlert,
          color: "#E4A11B",
          label: "Sub Admin",
        };
      default:
        return {
          icon: Shield,
          color: "#14A44D",
          label: "Admin",
        };
    }
  };

  const { icon: Icon, color, label } = getBadgeConfig();

  return (
    <Icon
      size={14}
      style={{
        color: color,
        strokeWidth: 2.5,
      }}
    />
  );
};

// Adjust import path as needed

// Loading indicator component for the dropdown

export const EditableTableCell = ({
  groupLevelList,
  data,
  isEditable,
  groupId,
}) => {
  console.log("inside editable field");
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState({
    value: data["_GROUP LEVEL"],
    label: data["GROUP LEVEL"],
  });

  const selectRef = useRef(null);
  const cellRef = useRef(null);
  const [options, setOptions] = useState(groupLevelList);
  const [updating, setUpdating] = useState(false);

  // Handle focus and click outside
  useEffect(() => {
    if (isEditing && selectRef.current) {
      selectRef.current.focus();
    }

    // Handle clicks outside the cell when editing
    const handleClickOutside = (event) => {
      if (
        cellRef.current &&
        !cellRef.current.contains(event.target) &&
        isEditing
      ) {
        // Only close if not in the middle of updating
        if (!updating) {
          handleBlur();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditing, updating]);

  const handleDoubleClick = () => {
    if (isEditable) {
      setIsEditing(true);
    }
  };

  const handleBlur = () => {
    // Only blur if not updating
    if (!updating) {
      setIsEditing(false);
    }
  };

  const updateUserLevel = async (selected, previousValue) => {
    setUpdating(true);
    try {
      var res = await updateGroupUser({
        groupId: groupId,
        levelId: selected.value,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
        regionId: data["_REGION"],
        siteId: data["_SITE"],
        userId: data["_USER ID"],
      });

      console.log(res, "res");
      if (res.status === "success") {
        setValue({
          value: selected.value,
          label: selected.label,
        });
        callToast("success", "Success", "User level updated successfully");
      } else {
        setValue(previousValue);
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error updating user level:", error);
      setValue(previousValue);
      callToast("error", "Error", "Failed to update user level");
    } finally {
      setUpdating(false);
      setIsEditing(false); // Close dropdown after updating completes
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      border: "1px solid #ced4da",
      borderRadius: "4px",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#adb5bd",
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "8px",
      color: "#495057",
      "&:hover": {
        color: "#495057",
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#ced4da",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "4px",
      borderRadius: "4px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
      zIndex: 9999, // Ensure dropdown stays on top
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isSelected ? "#e9ecef" : "white",
      color: "#212529",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <td
      ref={cellRef}
      onDoubleClick={handleDoubleClick}
      style={{
        padding: "8px",
        minWidth: "240px",
        cursor: isEditable ? "pointer" : "default",
        transition: "all 0.2s ease",
        position: "relative",
      }}
    >
      {isEditing ? (
        <Select
          ref={selectRef}
          autoFocus
          menuIsOpen
          isDisabled={updating}
          options={options}
          value={value}
          onChange={(selected) => {
            if (!updating) updateUserLevel(selected, value);
          }}
          styles={selectStyle}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={
            updating
              ? {
                  DropdownIndicator,
                }
              : null
          }
          blurInputOnSelect={false}
          closeMenuOnSelect={false}
        />
      ) : (
        <div
          style={{
            padding: "6px 12px",
            borderRadius: "4px",
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "#ced4da",
            },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{value.label}</span>
          {isEditable && (
            <span
              style={{
                opacity: 0.5,
                marginLeft: "4px",
                fontSize: "12px",
                display: "inline-flex",
              }}
            >
              <Edit2 size={14} />
            </span>
          )}
        </div>
      )}
    </td>
  );
};



export const AcademicYearSelect = memo(
  ({
    academicYearList,
    selectedAcademicYear,
    setSelectedAcademicYear,
    getThisTableData,
    selectStyle = {},
    errors,
    isSearchable = true,
    placeholder = "Select Academic Year",
  }) => {
    const handleAcademicYearChange = useCallback(
      (newValue) => {
        setSelectedAcademicYear(newValue);

        // Trigger table data refresh with the selected academic year
        if (getThisTableData) {
          getThisTableData({
            columnRefresh: true,
            isLoading: false,
            academicYearId: newValue?.value,
          });
        }
      },
      [setSelectedAcademicYear, getThisTableData]
    );

    const defaultSelectStyle = {
      control: (provided, state) => ({
        ...provided,
        minHeight: "32px",
        height: "32px",
        fontSize: "0.875rem",
        borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
        boxShadow: state.isFocused
          ? "0 0 0 0.2rem rgba(13, 110, 253, 0.25)"
          : "none",
        "&:hover": {
          borderColor: "#86b7fe",
        },
        transition: "all 0.2s ease",
        position: "relative",
        zIndex: 1000, // Increased z-index for control
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: "30px",
        padding: "0 6px",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorSeparator: () => ({
        display: "none",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "30px",
      }),
      placeholder: (provided) => ({
        ...provided,
        fontSize: "0.875rem",
        color: "#6c757d",
      }),
      singleValue: (provided) => ({
        ...provided,
        fontSize: "0.875rem",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Very high z-index for dropdown menu
        position: "absolute",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
        border: "1px solid #dee2e6",
        borderRadius: "0.375rem",
      }),
      menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999, // High z-index for portal
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? "#0d6efd"
          : state.isFocused
          ? "#f8f9fa"
          : "white",
        color: state.isSelected ? "white" : "#212529",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: state.isSelected ? "#0d6efd" : "#e9ecef",
        },
      }),
    };

    return (
      <div
        className="academic-year-select-container"
        style={{
          position: "relative",
          zIndex: 1000, // Container z-index
        }}
      >
        <Select
          options={academicYearList}
          value={selectedAcademicYear}
          styles={{ ...defaultSelectStyle, ...selectStyle }}
          onChange={handleAcademicYearChange}
          noOptionsMessage={() =>
            !isSearchable
              ? "Academic Year Access not available"
              : "No matches found"
          }
          isSearchable={isSearchable}
          placeholder={placeholder}
          className="basic-single hover-scale"
          classNamePrefix="select"
          filterOption={(option, inputValue) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuPlacement="auto"
          isLoading={!academicYearList || academicYearList.length === 0}
          components={{
            MenuPortal: ({ children, ...props }) => (
              <div {...props} style={{ ...props.style, zIndex: 9999 }}>
                {children}
              </div>
            ),
          }}
        />
        {errors?.academicYear && (
          <small className="text-danger fade-in">{errors.academicYear}</small>
        )}
      </div>
    );
  }
);